import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, Alert } from '../../../js/ComponentManager'

/* 개발담당:양유빈
 * 화면기능:채팅창
 * 세부설명:
*/

export class RtiQstDtl extends Component {
    static displayName = RtiQstDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            MasterData: [],
            ConverSationList: [],
            CommentList:[],
            Content:""
        };
        this.CsName = Big3Common.ContentState;
        this.Union_Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Union_Uid, null);
        this.QstgrpNo = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.QstgrpNo, null);
        this.handelComment_Save = this.handelComment_Save.bind(this);
        this.handle_Blur = this.handle_Blur.bind(this);
        this.handlePaper_Click = this.handlePaper_Click.bind(this);
        this.Comment = "";
        this.isSubmit = true; //코멘트 전송 가능여부(true면 전송, false면 전송불가)
    }
    //초기화
    async componentDidMount() {
         await this.CallQstMgtDtlListData();
    }
    componentDidUpdate() {
        const ContainerBox = document.getElementsByClassName("container_box")[0];
        const scrollY = ContainerBox.clientHeight;
        window.scrollTo({ top: scrollY, left: 0, behavior: "instant" });
    }
     //주문문의 조회(마스터+상태+코멘트 내역)
    async CallQstMgtDtlListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Model = {
                Qstgrp_No:this.QstgrpNo,
                Union_Uid: this.Union_Uid
            }
            let Data = await Big3Common.Post('api/Order/QuestionMgr/GetQstMgtConverSation',Model,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CallList = JSON.parse(Data.multiDataTable);
                this.setState({
                    MasterData: CallList.Master,
                    ConverSationList: CallList.ConverSationList,
                    CommentList: CallList.CommentList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtDtlListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //코멘트만 조회
    async CallQstmgtCommentListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Model = {
                Qstgrp_No: this.QstgrpNo,
                Union_Uid: this.Union_Uid
            }
            let Data = await Big3Common.Post('api/Order/QuestionMgr/GetQstmgtCommentList', Model,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CommentList = JSON.parse(Data.dataTable);
                this.setState({
                    CommentList: CommentList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstmgtCommentListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handle_Blur(event) {
        this.Comment = event.target.value;
    }
    //주문원장 이동
    handlePaper_Click(event,list) {
        
        //QA가 아닌것 있으면 이미 답변이 완료된 상태, StockQst(재고문의),StockQstCon(재고답변)
        const QstStatusList=this.state.ConverSationList.filter(Status =>Status.qst_status !=="QA");
        let CompName = list.qst_status === "QA" && QstStatusList.length === 0 ? "StockQst" : "StockQstCon";
        this.props.RenderComponent(CompName,
            {
                [this.CsName.Union_Uid]: this.Union_Uid,
                [this.CsName.QstgrpNo]: this.QstgrpNo,
                [this.CsName.QstStatus]: list.qst_status,
                [this.CsName.Whole_Name]: Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.Whole_Name,""),
                [this.CsName.SearchText]: Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchText, "")
            });
        event.preventDefault();
    }
     //코멘트 등록
    async handelComment_Save(event) {
        try {
            if (this.Comment === "") {
                this.setState({ Content: "문의내용을 입력하세요." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            if (!this.isSubmit) {
                return false;
            }
            this.isSubmit = false;
            let Data = await Big3Common.Post('api/Order/QuestionMgr/RegisterComment',
                {
                    Contt: this.Comment,
                    Union_Uid: this.Union_Uid,
                    Qstgrp_no: this.QstgrpNo
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.Comment = "";
                document.getElementById("Comment").value = "";
                this.CallQstmgtCommentListData();
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handelComment_Save: ", e)
        }
        finally {
            this.isSubmit = true;
        }
        event.preventDefault();
    }
     //기본정보
    Masterrender() {
        if (this.state.MasterData.length === 0) return false;
        const MasterData = this.state.MasterData[0];
        return (
            <div className="alert_content">
                <div className="alert_img">
                     <GoodsPhoto className="alert_img_in"
                        ImageSrc={MasterData.img_220}
                    />
                </div>
                <div className="alert_txt">
                    <div className="order_date od1">문의일자 : {MasterData.reg_dt}</div>
                    <div className="order_date od2">문의번호:  {MasterData.qstgrp_no}</div>
                    <div className="product_name">품목: {MasterData.goods_names}</div>
                    <div className="product_name">금액: {Big3Common.Util.Money(MasterData.goods_price)}원</div>
                    <div className="or_s_btn2">{MasterData.qstmgt_status_nm}</div>
                </div>
            </div>
        )
    }
    //상태에때른 대화 내역
    Statusrender() {

        if (this.state.ConverSationList.length === 0) return false;
        const ConverSationList = this.state.ConverSationList;
        //QA:재고문의, AN:재고답변, JM:상품주문, PJ:포장완료, GR:거래완료
        return (
            <div className="default_request_box">
                {
                    ConverSationList.map((list, idx) =>
                        <div className={idx % 2 === 0 ? "default_request_left_box pointer" : "default_request_right_box pointer"}
                            key={list.qst_status}
                            onClick={(e) => { this.handlePaper_Click(e,list) } }
                        >
                            <div className="txt">{list.qst_status_nm}</div>
                            <div className="arrow"></div>
                        </div>
                    )
                }
            </div>
        )
    }
     Commentrender() {
        if (this.state.CommentList.length === 0) {
            return false;
        }
        const CommentMap = Big3Common.Util.groupBy(this.state.CommentList, list => list.dayname);
        let CommentList = [];
        for (const item of CommentMap.entries()) {
            CommentList.push({ "DateName": item[0], "DtlList": item[1] });
         }
         function MessageBox(subList) {
             if (subList.user_idx === 'WH') {
                 return (
                     <>
                         <div className="Conversation">{subList.contt}</div>
                         <div className="chat_time">{subList.sendtime}</div>
                     </>
                 )
             }
             else {
                 return (
                     <>
                         <div className="chat_time">{subList.sendtime}</div>
                         <div className="Conversation">{subList.contt}</div>
                     </>
                 )
             }
         }
        return (
            <div className="chating_box">
                        <div className="select_box">
                            <div className="category_box reset" onClick={(e)=>{this.CallQstmgtCommentListData();e.preventDefault();}}>
                                <div className="category">새로고침</div>
                                <div className="reset_btn"></div>
                            </div>
                        </div>
                {
                    CommentList.map((list, idx) =>
                        <div key={idx }>
                            <div className="chat_date">{list.DateName}</div>
                            {
                                list.DtlList.map((subList, subidx) =>
                                    <div key={subidx} className={subList.user_idx === 'WH' ? "chatbox_right" : "chatbox_left"} >
                                        <div className="Conversation_box">
                                            {MessageBox(subList) }
                                            {
                                                subList.user_idx ==='WH' && subList.views===1 ? <div className="chat_check">{subList.views}</div> : ""
                                                //도매가 작성한 코멘트를 소매가 읽었는지 체크
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </div>
        )
    }
    render() {
        const Masterrender=this.Masterrender();
        const Statusrender=this.Statusrender();
        const Commentrender=this.Commentrender();
        return (
            <div>
                <div className="container_box p_c_margin d_padding ">
                   {Masterrender}
                   {Statusrender}
                   {Commentrender}
                </div>
                <div className="chat_input_box">
                        <div className="chat_input">
                        <input type="text" className="form-control" maxLength="100"
                            id="Comment"
                            onBlur={(e) => { this.handle_Blur(e) }}
                            placeholder="문의하실 내용을 입력해주세요." />

                        </div>
                        <div className="send_btn pointer"
                            onClick={(e) => { this.handelComment_Save(e) }}></div>
                </div>
                  <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="주문문의안내"
                />
            </div>
        );
    }
}
